import { useEffect } from "react";

export default function ScrollToTopOnMount() {

  return null;
}